import { GettyOrderDetailModel } from '../admin/models/getty.order.detail.model';

export class AddGettyOrderModel {
    public fileKey: string;
    public fileName: string;
    public totalRecords: number;
    public details: Array<GettyOrderDetailModel>;

    constructor() {
        this.details = new Array<GettyOrderDetailModel>();
    }
}
